import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ source, onRemove, onUpdate, onDuplicate }) => {
    const countries = source.countries ? source.countries.join(', ') : '';

    return (<tr>
        <td style={{ textAlign: 'left' }}>{source.name}</td>
        <td>{source.type}</td>
        <td>{countries}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(source)}>Update</Button>
                <Button bsStyle="info" onClick={() => onDuplicate(source)}>Duplicate</Button>
                <Button bsStyle="danger" onClick={() => onRemove(source.name)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);

};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesCountry/components/Table/components/Row/index.js